// extracted by mini-css-extract-plugin
export default {"container":"MobileBgOrangeBlur_container__Bt2ee"};